import { useEffect, useState } from 'react';

export default function useScrollDirection() {
  const [scrollDirection, setScrollDirection] = useState<'down' | 'up' | null>(
    null,
  );
  const [scrollY, setScrollY] = useState<number>(0);

  useEffect(() => {
    const threshold = 0;
    let lastScrollY = window.pageYOffset;
    let ticking = false;

    const updateScrollDir = () => {
      const _scrollY = window.pageYOffset;
      setScrollY(_scrollY);

      if (Math.abs(_scrollY - lastScrollY) < threshold) {
        ticking = false;
        return;
      }
      setScrollDirection(_scrollY > lastScrollY ? 'down' : 'up');
      lastScrollY = _scrollY > 0 ? _scrollY : 0;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [scrollDirection]);

  return { scrollDirection, scrollY };
}
